






























































































import { arrayEquals } from "@/util";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

export interface ValueText {
  value: number;
  text: string;
}

@Component
export default class SelectAll extends Vue {
  @Prop({ required: false }) label!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ required: true }) items!: ValueText[];
  @Prop({ required: false }) value!: number[];

  selectedValues: number[] = [];
  searchValue = "";

  @Watch("value")
  onFilter() {
    this.refreshValue();
  }

  @Watch("selectedValues")
  onSelected(value: number[]) {
    this.$emit("input", value);
  }

  openTest() {
    this.searchValue = "";
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  showItem(value: string) {
    if (!this.searchValue) return true;
    if (value.toLowerCase().includes(this.searchValue.toLowerCase())) return true;
    return false;
  }

  refreshValue() {
    if (Array.isArray(this.value)) {
      if (!arrayEquals(this.selectedValues, this.value)) {
        this.selectedValues = this.value as number[];
      }
    }
  }

  selectAllIcon(): string {
    if (this.selectedValues.length === this.items.length) return "mdi-close-box";
    if (this.selectedValues.length > 0) return "mdi-minus-box";
    return "mdi-checkbox-blank-outline";
  }

  selectAllOfficesIcon() {
    console.log(this.selectedValues.length);
    if (this.selectedValues.length == 0) return "mdi-close-box";
    return "mdi-checkbox-blank-outline";
  }

  selectAllOfficesIconCss() {
    return this.selectedValues.length == 0 ? "indigo darken-4" : "";
  }

  selectAllIconCss(): string {
    return this.selectedValues.length > 0 ? "indigo darken-4" : "";
  }

  selectAllToggle(force?: boolean) {
    if (!force && this.selectedValues.length === this.items.length) {
      this.onSelected([]);
    } else {
      const filteredItems = this.items.filter(
        (t) => this.showItem(t.text + t.value) || this.selectedValues.includes(t.value)
      );
      this.onSelected([...(filteredItems || []).map((t) => t.value)]);
    }
  }

  selectAllOffices() {
    this.onSelected([]);
  }

  selectedFilterLabels(): string {
    return this.selectedValues.map((v) => this.items.find((o) => o.value === v)?.text || v).join(", ");
  }

  created() {
    this.refreshValue();
  }
}
